/**
 * 名人案例。数据硬编码在 src/data/famous.ts（旧站也是如此，不走后端）。
 * vipOnly 条目未开会员时遮蔽干支，与旧站口径一致。
 */
import { useMemo, useState } from "react";
import { famousCases, famousCategories } from "../data/famous";
import { useMembership } from "../hooks/useMembership";
import { legalNotice } from "../data/site";
import { onNavClick } from "../router";

const ALL = "全部";

export function FamousPage({ onNavigate }: { onNavigate: (route: string) => void }) {
  const [category, setCategory] = useState(ALL);
  const { isVip, signedIn } = useMembership();

  const list = useMemo(
    () => (category === ALL ? famousCases : famousCases.filter((item) => item.category === category)),
    [category],
  );

  return (
    <main className="page famous-page">
      <h1>名人案例</h1>
      <p className="page-summary">
        历史人物的四柱干支资料汇编，用于对照学习与排盘练习。
      </p>

      <div className="famous-filter" role="tablist" aria-label="分类筛选">
        {[ALL, ...famousCategories].map((item) => (
          <button
            key={item}
            type="button"
            role="tab"
            aria-selected={category === item}
            className={category === item ? "active" : undefined}
            onClick={() => setCategory(item)}
          >
            {item}
          </button>
        ))}
      </div>

      <ul className="famous-list">
        {list.map((item) => {
          const locked = item.vipOnly && !isVip;
          return (
            <li key={item.name} className={locked ? "locked" : undefined}>
              <div className="famous-avatar" aria-hidden="true">
                {item.name.slice(0, 1)}
              </div>
              <div className="famous-main">
                {locked ? (
                  <strong>{item.name}</strong>
                ) : (
                  <a
                    className="famous-link"
                    href={`/famous/${item.slug}`}
                    onClick={(e) => onNavClick(e, `famous/${item.slug}`, onNavigate)}
                  >
                    <strong>{item.name}</strong>
                  </a>
                )}
                <span className="famous-sex">{item.sex}</span>
                <span className="famous-note">{item.note}</span>
              </div>
              {locked ? (
                <button type="button" className="famous-locked" onClick={() => onNavigate("vip")}>
                  会员可见
                </button>
              ) : (
                <div className="famous-pillars" aria-label={`${item.name}四柱`}>
                  <div className="famous-row">
                    {[...item.tg].map((ch, i) => (
                      <span key={`tg-${i}`}>{ch}</span>
                    ))}
                  </div>
                  <div className="famous-row">
                    {[...item.dz].map((ch, i) => (
                      <span key={`dz-${i}`}>{ch}</span>
                    ))}
                  </div>
                </div>
              )}
            </li>
          );
        })}
      </ul>

      {!signedIn && (
        <p className="empty-state">
          部分案例为会员内容，
          <button type="button" onClick={() => onNavigate("auth")}>
            登录
          </button>
          后可查看开通状态。
        </p>
      )}

      <p className="paipan-notice">{legalNotice}</p>
    </main>
  );
}
